import { FC, useEffect } from 'react'
import Header from '../components/layouts/Header'
import SideBar from '../components/layouts/SideBar'
import Footer from '../components/layouts/Footer'
import { Outlet } from 'react-router-dom'
import {
  reloadActiveRelations,
  reloadBatches,
  reloadSchool,
  reloadTanks,
} from '../utils/loadStorage'
import { useActiveRelationStore, ARInfoBase } from '../store/activeRelation/useActiveRelationStore'

const Layout: FC = () => {
  const storedARList = useActiveRelationStore((state) => state.activeRelations)

  useEffect(() => {
    reloadBatches()
    reloadTanks()
    reloadActiveRelations()
  }, [])

  useEffect(() => {
    const schoolIdList: string[] = []
    Object.keys(storedARList).forEach((batchId) => {
      storedARList[batchId].forEach((info: ARInfoBase) => {
        if (info.schoolId) {
          schoolIdList.push(info.schoolId)
        }
      })
    })
    reloadSchool(schoolIdList)
  }, [storedARList])

  return (
    <>
      <Header />
      <div className="flex flex-row">
        <SideBar />
        <main className="bg-tdplbisque bg-repeat-y w-screen min-h-[100lvh]">
          <Outlet />
        </main>
      </div>
      <Footer />
    </>
  )
}

export default Layout
